'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdShuffle = function MdShuffle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.7 22.3l5.2 5.3 3.5-3.5v9.3h-9.3l3.5-3.5-5.3-5.2z m-0.6-15.7h9.3v9.3l-3.5-3.5-20.9 21-2.4-2.4 21-20.9z m-6.4 8.7l-2.4 2.4-8.7-8.7 2.4-2.4z' })
        )
    );
};

exports.default = MdShuffle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/shuffle.js
// module id = 3535
// module chunks = 0